export const NOMINATION_PAGE_CONST = {
    localStorage: {
        sidebarCollapsedKey: 'nominationSidebarCollapsed',
    },
    collapsedWidth: 40,
    expandedWidth: 260,
    tabContentHeight: 'calc(100vh - 156px)', // Adjusted to match the height of the sidebar content
};
